import { Component, input } from '@angular/core';
import { InError } from './documents-view/in-error/in-error';
import { Processed } from './documents-view/processed/processed';
import { ToProcess } from './documents-view/to-process/to-process';

@Component({
  selector: 'app-documents',
  standalone: true,
  imports: [ToProcess, Processed, InError],
  templateUrl: './documents.html',
  styleUrl: './documents.scss'
})
export class Documents {
  // Riceviamo la vista selezionata dalla Home
  viewType = input.required<string>();
}